import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../context/AuthContext';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../../../firebase';

const TotalCount = ({ propID }) => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [totalCount, setTotalCount] = useState(0);

  async function getAllTowers(propID) {
    const q = query(collection(db, "Businesses", bid, "Properties", propID, "Towers"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      var tempCount = 0;
      querySnapshot.forEach((doc) => {
        tempCount = parseFloat(tempCount) + (parseFloat(doc.data().numFloors) * parseFloat(doc.data().totalUnitCount));
      });

      setTotalCount(tempCount);
    }, (error) => {
      console.log(error.message);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    getAllTowers(propID);
  }, [])

  return totalCount;
}

export default TotalCount;
